import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

const JabatanSelectorFilter = (props) => {
  const { filterValue, setFilterValue, onClickRefresh } = props;

  const handleOnKeyDown = (e) => {
    if (e.key === "Enter") {
      if (onClickRefresh) onClickRefresh();
    }
  };

  return (
    <div className="row-between-end gap-4 w-full">
      {/* filter component section */}
      <div className="row-start-center gap-2 w-full">
        <div className="p-inputgroup flex-1 h-[2.4rem]">
          <span className="text-sm p-inputgroup-addon">Kode</span>
          <InputText
            value={filterValue.kode}
            onChange={(e) =>
              setFilterValue({ ...filterValue, kode: e.target.value })
            }
            onKeyDown={handleOnKeyDown}
            className="w-full h-[2.4rem]"
          />
        </div>
        <div className="p-inputgroup flex-1 h-[2.4rem]">
          <span className="text-sm p-inputgroup-addon">Nama</span>
          <InputText
            value={filterValue.nama}
            onChange={(e) =>
              setFilterValue({ ...filterValue, nama: e.target.value })
            }
            onKeyDown={handleOnKeyDown}
            className="w-full h-[2.4rem]"
          />
        </div>
      </div>
      {/* refresh section */}
      <Button
        icon="pi pi-refresh"
        outlined
        rounded
        onClick={() => {
          if (onClickRefresh) onClickRefresh();
        }}
      />
    </div>
  );
};

export default JabatanSelectorFilter;
